import classes from './tooltip.module.scss';

const tooltip = props => {
	return (
		<div className={classes.tooltip}>
			{props.children}
			{props.message && props.message.length > 0 ? (
				<div className={classes.tooltiptext}>{props.message}</div>
			) : null}
		</div>
	);
};

export default tooltip;
